import Zoom from "@arcgis/core/widgets/Zoom";
import Extent from "@arcgis/core/geometry/Extent";

import "./ZoomHome.css";
import { forwardRef } from "react";

interface iProps {
	view: __esri.MapView;
	extent: Extent;
}

const ZoomHome = forwardRef<HTMLDivElement, iProps>(({ view, extent }, ref) => {
	const zoom = new Zoom({ view: view });

	const goHome = () => {
		view?.goTo({
			target: extent
		});
	}

	const zoomIn = () => {
		zoom.zoomIn();
	}

	const zoomOut = () => {
		zoom.zoomOut();
	}

	return (
		<div ref={ref} className="esri-component zoom-home">
			<div className="esri-component zoom-in-btn" role="button" onClick={zoomIn}>
				<div className="esri-widget--button esri-widget esri-interactive">
					<span className="esri-icon esri-icon-plus"></span>
				</div>
			</div>
			<div className="esri-component esri-widget--button esri-widget home-btn" role="button" onClick={goHome}>
				<div className="home-btn-container esri-widget--button esri-widget esri-interactive">
					<span className="esri-icon esri-icon-home"></span>
				</div>
			</div>
			<div className="esri-component zoom-out-btn" role="button" onClick={zoomOut}>
				<div className="esri-widget--button esri-widget esri-interactive">
					<span className="esri-icon esri-icon-minus"></span>
				</div>
			</div>
		</div>
	);
});

export default ZoomHome;